import { Component, HostListener, Input, OnInit } from '@angular/core';
import * as d3 from 'd3';

@Component({
  selector: 'app-scorerace',
  templateUrl: './scorerace.component.html',
  styleUrls: ['./scorerace.component.css']
})
export class ScoreraceComponent implements OnInit {
@Input('testRecord') public testRecord:any;
public examType :any = ''
  @HostListener('window:resize', ['$event'])
  onresize(event) {
    this.loadSvg()
  }
  constructor() { }

  ngOnInit(): void {
this.examType = localStorage.getItem('targetExamName')
  }
  ngAfterViewInit() {
    //  this.loadSvg()
  }
  ngOnChanges(){
    console.log(this.testRecord)
    this.loadSvg()
  }
  loadSvg(){
    d3.select('#racecourse').select('svg').remove()
    var svg = d3.select('#racecourse')
      .append('svg')
      .style('background-color', '#fff')
      .attr('width', document.getElementById('racecourse').offsetWidth)
      .attr('height', 216)    
    this.raceCourseGraph(svg);
  }
  raceCourseGraph(svg) {
    var maximumMarks = this.testRecord?.outOfScore||0
    var lowestScore = this.testRecord?.lowestScore||0;
    var cutOffMark =  this.testRecord?.newCutoff||this.testRecord?.cutoffScore||0;
    var HigeshtMark =  this.testRecord?.highestScore||0;
    var userScore = this.testRecord?.totalScore||0;

//  var maximumMarks = 720
    // var lowestScore = 4;
//     var cutOffMark = 180;
//     var HigeshtMark =  280;
    // var userScore = -150;

    let totalDivwidth = document.getElementById('racecourse').offsetWidth;
    let totalDivheight = document.getElementById('racecourse').offsetHeight;
    /////////////////////////Svg Scale Starts/////////////////////////////////////////////////////////////
    let one_percent_width = totalDivwidth * 0.01;
    let one_percent_height = totalDivheight * 0.01;
    let margin = {
      left: 0,
      right: one_percent_width * 5,
      bottom: one_percent_height * 5,
      top: one_percent_height * 5
    }
    var used_svgWidth = totalDivwidth - margin.left - margin.right;
    var used_svgHeight = totalDivheight - margin.top - margin.bottom;

    /////////////////////////Svg Scale Ends/////////////////////////////////////////////////////////////
    /////////////////////////////Scale Calculation Starts/////////////////////////////////////////////////////////
    const redZonePercentage = 0.2// 20 percentage
    var posXscale = d3.scaleLinear()
      .domain([0, maximumMarks]) // unit: Marks
      .range([(used_svgWidth * redZonePercentage), used_svgWidth]) // unit: pixels
    var negXscale = d3.scaleLinear().domain([-maximumMarks, 0]) // unit: Marks
      .range([0, used_svgWidth * redZonePercentage]) // unit: pixels

    var Yscale = d3.scaleLinear()
      .domain([0, used_svgHeight]) // unit: Marks
      .range([used_svgHeight, 0])
    /////////////////////////////Scale Calculation Ends/////////////////////////////////////////////////////////
    /////////////////////////Road Lane Starts/////////////////////////////////////////////////////////////
    // Horizontally SVG 20 percent is for negative marking and 80percent is for positive marking
    var negative_range = used_svgWidth * redZonePercentage;//20 percent -ve zone
    var roadcouse = svg.append('g').attr("transform", `translate(0,${Yscale(used_svgHeight * 0.4)})`)//vertically SVG divided into 60% to 40%
   let finalpoint = this.MobileScreen()? posXscale(maximumMarks ) -one_percent_width :posXscale(maximumMarks );
   roadcouse.append('rect')
   .attr("width", this.MobileScreen()? finalpoint-(one_percent_width*4 ) :finalpoint)
   .attr("height", one_percent_height * 2)
   .attr("fill",'#D9DBE9')
    let endIndex = ((used_svgWidth -(this.MobileScreen()? one_percent_width*4 :0))/ 21)
    for (let index = 0; index < finalpoint/20; index++) {
      let redZone = (index * 20 < negative_range || index * 20 == negative_range) ? true : false;
      roadcouse.append('rect')
        .attr("width", one_percent_width * 1.69)
        .attr("height", one_percent_height * 2)
        .attr("x", index * 20)
        .attr("y", 0)
        .attr("fill", redZone ? (index % 2 == 0 ? '#D9A3A3' : '#EECCCC') : (index % 2 == 0 ? '#A0A3BD' : ( this.MobileScreen() ? '#A0A3BD':'#D9DBE9')))
    }
    var zeroText = svg.append('g')
                   .append('text')
                   .text("0")
                   .attr("x",posXscale(0))
                   .attr('y',(Yscale(used_svgHeight*0.25 )))
                    .style('font-weight',400)
                    .attr('fill','#1E2A36')

    /////////////////////////////Road Lane Ends/////////////////////////////////////////////////////////
    /////////////////////////////Race Flag Starts/////////////////////////////////////////////////////////

    var singleRectheight = one_percent_height * 3.5;
    if(window.innerWidth > 319 && window.innerWidth <  581){
      singleRectheight = one_percent_height * 2.2;
    }
    let alreadytaken = '#EFF0F6';
    var startflag = svg.append('g')
      .attr("transform", `translate(${posXscale(0)},${Yscale((used_svgHeight * 0.42)+(4*singleRectheight) )})`)
    startflag.selectAll('rect')
      .data([[0, 0], [1, 0], [0, 1], [1, 1], [0, 2], [1, 2], [0, 3], [1, 3],[0, 4], [1, 4]])
      .enter()
      .append('rect')
      .attr('height', singleRectheight)
      .attr('width', singleRectheight)
      .attr('x', (v, i) => {
        return v[0] * singleRectheight
      })
      .attr('y', (v, i) => {
        return   v[1] * singleRectheight
      })
      .attr('fill', (v, i) => {
        alreadytaken = !i ? '#EFF0F6' : (i % 2 == 0 ? (alreadytaken) : (alreadytaken == '#EFF0F6' ? '#4E4B66' : '#EFF0F6'))
        return alreadytaken
      })
    /////////////////////////////Race Flag Ends/////////////////////////////////////////////////////////
    ///////////////////////////Userscore Pole Start/////////////////////////////////////////////////////////

    let userScoreRepresentation = userScore < 0 ? negXscale(userScore) : posXscale(userScore)
    //Create a radial Sun-like gradient
    var defs = svg.append('g').append("defs");
    defs.append("radialGradient")
      .attr("id", "sun-gradient")
      .attr("cx", "50%")	//not really needed, since 50% is the default
      .attr("cy", "50%")	//not really needed, since 50% is the default
      .attr("r", "50%")	//not really needed, since 50% is the default
      .selectAll("stop")
      .data([
        { offset: "25%", color: "#79BC83" },
        { offset: "45%", color: "#BCF1C3" },
        { offset: "75%", color: "#D7FADC" },
        { offset: "100%", color: "#ECFFEE" }
      ])
      .enter().append("stop")
      .attr("offset", function (d) { return d.offset; })
      .attr("stop-color", function (d) { return d.color; });
      svg.append("g").append("circle")
    .attr("transform", `translate(${posXscale(0)},${Yscale(used_svgHeight * 0.7)})`)
    .transition()
    .duration(3000)
    .attr("transform", `translate(${userScoreRepresentation},${Yscale(used_svgHeight * 0.7)})`)
      .attr("r", 28)
      // .style("fill", "url(#sun-gradient)"); gradient
    .attr("fill","#ECFFEE")

    svg.append("g").append("circle")
    .attr("transform", `translate(${posXscale(0)},${Yscale(used_svgHeight * 0.7)})`)
    .transition()
    .duration(3000)
    .attr("transform", `translate(${userScoreRepresentation},${Yscale(used_svgHeight * 0.7)})`)
      .attr("r", 23)
      // .style("fill", "url(#sun-gradient)"); gradient
    .attr("fill","#D7FADC")
    svg.append("g").append("circle")
    .attr("transform", `translate(${posXscale(0)},${Yscale(used_svgHeight * 0.7)})`)
    .transition()
    .duration(3000)
    .attr("transform", `translate(${userScoreRepresentation},${Yscale(used_svgHeight * 0.7)})`)
      .attr("r", 17)
      // .style("fill", "url(#sun-gradient)"); gradient
    .attr("fill","#BCF1C3")
    svg.append("g").append("circle")
    .attr("transform", `translate(${posXscale(0)},${Yscale(used_svgHeight * 0.7)})`)
    .transition()
    .duration(3000)
    .attr("transform", `translate(${userScoreRepresentation},${Yscale(used_svgHeight * 0.7)})`)
      .attr("r", 13)
      // .style("fill", "url(#sun-gradient)"); gradient
    .attr("fill","#79BC83")


    var userscorepole = svg.append('g')
      .append('line')
      .style("stroke", "#A5AAAF")
      .style("stroke-width", 2)
      .attr('y1', Yscale(used_svgHeight * 0.55))
      .attr('y2', Yscale(used_svgHeight * 0.4))
      .attr('x1',posXscale(0))
      .attr('x2', posXscale(0))
      .transition()
      .duration(3000)
      .attr('y1', Yscale(used_svgHeight * 0.55))
      .attr('y2', Yscale(used_svgHeight * 0.4))
      .attr('x1', userScoreRepresentation)
      .attr('x2', userScoreRepresentation)
    let check_overlapping = (userScore ==HigeshtMark ||userScore ==  cutOffMark ||userScore == lowestScore)? true : false
    var youtext = svg.append('g')
    .append("text")
    .text("You")
    .attr("x",posXscale(0))
    .attr('y',( Yscale(used_svgHeight*0.25 )))
    .attr('fill','#1E2A36')
    .style('font-weight',600)
    .transition()
    .duration(3000)
    .attr('x',userScoreRepresentation-5);

    var youScore = svg.append('g')
    .append('text')  
    .text(userScore)
    .attr('y',(  (Yscale(used_svgHeight*0.10 ))))
    .attr('x', posXscale(0))
    // .attr('class','font-weight-bold')
    .style('font-weight',800)
    .attr("fill",userScore ==lowestScore ?'#EC9191' :"#79BC82")
    .transition()
  .duration(3000)
  .attr('x',userScoreRepresentation-5);
    ///////////////////////////Userscore Pole Ends/////////////////////////////////////////////////////////
    /////////////////////////////Lowest  MArks Starts/////////////////////////////////////////////////////////
    let lowscore_represntation = lowestScore < 0 ? negXscale(lowestScore) : posXscale(lowestScore)
    // var triangle = d3.symbol().type(d3.symbolTriangle).size(one_percent_width * 25);
        svg.append('g')
    .append("svg:image")
      .attr("xlink:href", "assets/img/lowest-red-arrow.svg")
      .attr("transform", `translate(${lowscore_represntation-10},${(Yscale(used_svgHeight * 0.65))})  `)
      // .append("path")
      // .attr("d", triangle)
      // .attr('fill', "#EC9191")
    var pole = svg.append('g')
      .append('line')
      .style("stroke", "#A5AAAF")
      .style("stroke-width", 2)
      .attr('y1', Yscale(used_svgHeight * 0.5))
      .attr('y2', Yscale(used_svgHeight * 0.4))
      .attr('x1', lowscore_represntation)
      .attr('x2', lowscore_represntation)
      // var lowText = svg.append('g')
      //             .attr("name","low Text")
      //               .append('text')  
      //               .text("Low")
      //               .attr('y',(Yscale(used_svgHeight*0.25 )))
      //               .attr('x', lowscore_represntation)
      // var lowScore = svg.append('g')
      //   .append('text')  
      //   .text(lowestScore)
      //   .attr('y',(Yscale(used_svgHeight*0.15 )))
      //   .attr('x', lowscore_represntation)
      // .attr('class','font-weight-bold')

    ////////////////////////////Lowest  MArks Ends/////////////////////////////////////////////////////////
    /////////////////////////////cut Off  MArks Starts/////////////////////////////////////////////////////////
    let cutoffMArksRepresentation = cutOffMark < 0 ? negXscale(cutOffMark) : posXscale(cutOffMark)
   if(cutOffMark!=0) {
    svg.append('g')
      .attr("transform", `translate(${cutoffMArksRepresentation - 9},${(Yscale(used_svgHeight * 0.65))})`)
      .append("svg:image")
      .attr("xlink:href", "assets/img/scissor.svg")

    var cutoffpole = svg.append('g')
      .append('line')
      .style("stroke", "#A5AAAF")
      .style("stroke-width", 2)
      .attr('y1', Yscale(used_svgHeight * 0.50))
      .attr('y2', Yscale(used_svgHeight * 0.40))
      .attr('x1', cutoffMArksRepresentation)
      .attr('x2', cutoffMArksRepresentation)
    //   var CutOff = svg.append('g')
    // .append("text")
    // .text("CutOff")
    // .attr("x",cutoffMArksRepresentation-15)
    // .attr('y',(Yscale(used_svgHeight*0.25 )))
    // var cutoffScore = svg.append('g')
    //   .append('text')  
    //   .text(cutOffMark)
    //   .attr('y',(Yscale(used_svgHeight*0.15 )))
    //   .attr('x', cutoffMArksRepresentation)
    //   .attr('class','font-weight-bold')
    }

    ////////////////////////////cut Off  MArks Ends/////////////////////////////////////////////////////////
    //////////////////////////// End Flag starts /////////////////////////////////////////////////////////
    let max_posXscale = this.MobileScreen()?( posXscale(maximumMarks)-(one_percent_width*4 ) ):posXscale(maximumMarks)
    let flag = svg.append('g')
      .append("svg:image")
      .attr("xlink:href", "assets/img/flag.svg")
      .attr('x', max_posXscale)
      .attr('y',Yscale((used_svgHeight * 0.70)) )
    let flagPoleSupport = svg.append('g')
      .append('rect')
      .attr("width", singleRectheight)
      .attr("height", singleRectheight)
      .attr('x', posXscale(maximumMarks ) - (this.MobileScreen()?(one_percent_width*4 ):0))
      .attr('y', Yscale((used_svgHeight * 0.40)))
    // svg.append('g')
    //   .append('line')
    //   .style("stroke", "rgb(201, 186, 241)")
    //   .attr('y1', Yscale(used_svgHeight * 0.55))
    //   .attr('y2', Yscale(used_svgHeight * 0.4))
    //   .attr('x1', max_posXscale)
    //   .attr('x2', max_posXscale)
      var MaxText = svg.append('g')
      .append("text")
      .text("Max")
      .attr("x",this.MobileScreen()? (max_posXscale - one_percent_width*2) :max_posXscale )
      .attr('y',(Yscale(used_svgHeight*0.25 )))
    .style('font-weight',400)
    .attr('fill','#1E2A36')

      var maxScore = svg.append('g')
      .attr("name","low Text")
        .append('text')  
        .text(maximumMarks)
        .attr('y',(Yscale(used_svgHeight*0.10 )))
        .attr('x', this.MobileScreen()? (max_posXscale - one_percent_width*2) :max_posXscale)
      .attr('class','font-weight-bold')

    ////////////////////////////End Flag Ends/////////////////////////////////////////////////////////
    ////////////////////////////Star Pole Start/////////////////////////////////////////////////////////
    let HighestMArksRepresentation = HigeshtMark < 0 ? negXscale(HigeshtMark) : posXscale(HigeshtMark)
    svg.append('g')
      .attr("transform", `translate(${HighestMArksRepresentation - 10},${(Yscale(used_svgHeight * 0.68))})`)
      .append("svg:image")
      .attr("xlink:href", "assets/img/star-purple.svg")
    var cutoffpole = svg.append('g')
      .append('line')
      .style("stroke", "#A5AAAF")
      .style("stroke-width", 2)
      .attr('y1', Yscale(used_svgHeight * 0.50))
      .attr('y2', Yscale(used_svgHeight * 0.4))
      .attr('x1', HighestMArksRepresentation)
      .attr('x2', HighestMArksRepresentation)
    //   var highText = svg.append('g')
    // .append("text")
    // .text("High")
    // .attr("x",HighestMArksRepresentation-5)
    // .attr('y',(Yscale(used_svgHeight*0.25 )))
    // var highScore = svg.append('g')
    //   .append('text')  
    //   .text(HigeshtMark)
    //   .attr('y',(Yscale(used_svgHeight*0.15 )))
    //   .attr('x', (HighestMArksRepresentation-5))
    //   .attr('class','font-weight-bold')
    ////////////////////////////Star Pole Ends/////////////////////////////////////////////////////////
    
     ///////////////////////////negative mark start/////////////////////////////////////////////////////////
     var negativemark_line1 = svg.append('g')
     .append('text')  
     .text('Negative')
     .style("line-height","22px")
     .style("font-weight","400")
     .attr('fill','#1E2A36')
     .attr('y',(Yscale(used_svgHeight*0.55 )))
     .attr('x', (negXscale(-maximumMarks/2)));
     var negativemark_line2 = svg.append('g')
     .append('text')  
     .text('Marks')
     .attr('fill','#1E2A36')
     .style("line-height","22px")
     .style("font-weight","400")
     .attr('y',(Yscale(used_svgHeight*0.45 )))
     .attr('x', (negXscale(-maximumMarks/2)));
     if(window.innerWidth > 319 && window.innerWidth <  581){
      negativemark_line1.style('font-size',"8px")
      negativemark_line2.style('font-size',"8px")
      negativemark_line1.attr('x', (negXscale(-maximumMarks/1.5)));
      negativemark_line2.attr('x', (negXscale(-maximumMarks/1.5)));

     }
      ///////////////////////////negative mark start end/////////////////////////////////////////////////////////
// if(check_overlapping){
//   if(userScore ==HigeshtMark){
//     highScore.attr("fill",'none')
//   }else if(userScore ==cutOffMark){
//     cutoffScore.attr("fill",'none')
//   }else if(userScore ==lowestScore){
//     lowScore.attr("fill",'none')

//   }

   
      

// }
  }
MobileScreen(){
  return (window.innerWidth > 319 && window.innerWidth <  581)
}
}
